import { BuildType } from '@shared/enums/build.type';
import { Language } from '@shared/interfaces/users/users.interface';

export interface BuildDefaults {
  language: string;
  locale: Language;
  languageName: string;
  currency: string;
  phonePattern: string;
}

const RUSSIAN_PHONE_PATTERN = '^((\\+7|8)+([0-9]){10})$';

// The app-wide start values used before these defaults existed; KZ and TR keep them until their own
// start language, currency and phone format are agreed and checked on those builds
const NEUTRAL_DEFAULTS: BuildDefaults = {
  language: 'en',
  locale: 'en-US',
  languageName: 'English',
  currency: 'USD',
  phonePattern: RUSSIAN_PHONE_PATTERN,
};

// What the build assumes about its region until /users/me tells otherwise:
// the Transloco language (it also backs up missing keys), the locale used for
// dates and numbers, the currency and the phone format.
// RU starts in Russian: the privacy policy (RU only) renders outside the layout before /users/me.
export const BUILD_DEFAULTS: Record<BuildType, BuildDefaults> = {
  ['ru']: { language: 'ru', locale: 'ru-RU', languageName: 'Русский', currency: 'RUB', phonePattern: RUSSIAN_PHONE_PATTERN },
  ['kz']: NEUTRAL_DEFAULTS,
  ['tr']: NEUTRAL_DEFAULTS,
};
